<div>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="small"><i class="fas fa-camera"></i> {{ scope.title }}</h1>
        </div>
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" *ngIf="scope.info">
          <gs-video [id]="scope.id" [info]="scope.info"></gs-video>
          <!-- <vg-player class="player" (onPlayerReady)="onPlayerReady($event)">
            <vg-controls>
              <vg-play-pause></vg-play-pause>
              <vg-playback-button></vg-playback-button>
              <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
              <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>
              <vg-time-display vgProperty="left" vgFormat="mm:ss"></vg-time-display>
              <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
      
              <vg-track-selector></vg-track-selector>
              <vg-mute></vg-mute>
              <vg-volume></vg-volume>
              <vg-fullscreen></vg-fullscreen>
              <video
                [vgMedia]="media"
                #media
                id="singleVideo"
                preload="auto"
                muted
                crossorigin
              >
              <source src="{{ scope.videoUrl }}" />
            </video>              
            </vg-controls>
          </vg-player> -->
        </div>
      </div>
    </div>
  </section>
</div>
